import styled from 'styled-components';
import { darken, lighten, rgba } from 'polished';
import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';

const Button = styled.div`
  display: flex;
  flex-direction: column;
  width: 150px;
  height: 150px;
  margin: 10px;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  color: #fff;

  background: linear-gradient(60deg, ${(props) => lighten(0.15, props.color)}, ${(props) => props.color});
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14), 0 7px 10px -5px ${(props) => rgba(darken(0.2, props.color), 0.4)};

  &:hover {
    cursor: pointer;
    background: linear-gradient(60deg, ${(props) => props.color}, ${(props) => darken(0.1, props.color)});
  }

  &.disabled:hover {
    cursor: pointer;
    background: linear-gradient(60deg, ${(props) => lighten(0.15, props.color)}, ${(props) => props.color});
  }
`;

const PaymentButton = ({ children, disabled = false, loading = false, onClick, color }) => {
  let bgColor = color;
  if (disabled) {
    bgColor = '#aaaaaa';
  }
  return (
    <Button color={bgColor} className={disabled && 'disabled'} onClick={!disabled ? onClick : null}>
      {children}
      {loading && <CircularProgress size={50} style={{ position: 'absolute' }} />}
    </Button>
  );
};

export default PaymentButton;
